import { render, staticRenderFns } from "./ContributorsListTable.vue?vue&type=template&id=0a0337fa"
import script from "./ContributorsListTable.vue?vue&type=script&lang=js"
export * from "./ContributorsListTable.vue?vue&type=script&lang=js"
import style0 from "./ContributorsListTable.vue?vue&type=style&index=0&id=0a0337fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports